import TitleText from "app/containers/Auth/components/TitleText";
import { actions } from "app/containers/OnBoarding/redux/slice";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import BottomSection from "./BottomSection";
import { StageRenderer } from "./StageRenderer";
import { createStages } from "./stages";
import { useSetupForm } from "./useSetupForm";

export default function Setup() {
  const [currentStage, setCurrentStage] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { form, onboardingList, loading, setFormValue, saveForm } = useSetupForm();

  useEffect(() => {
    dispatch(actions.getOnbordingList());
  }, [dispatch]);

  const STAGES = useMemo(
    () => createStages(onboardingList, form, setFormValue),
    [onboardingList, form]
  );

  const currentStageData = STAGES[currentStage];

  const handleNext = () => {
    if (currentStage === STAGES.length - 1) return navigate("/app/home");
    setCurrentStage((prev) => prev + 1);
  };

  const handleBack = () => setCurrentStage((prev) => Math.max(0, prev - 1));

  const isNextDisabled = () => {
    if (currentStage === 0 && !form.companySize.value) return true;
    if (currentStage === 1 && !form.referalSource.value) return true;
    if (currentStage === 2 && form.toolPreferences.value?.length === 0) return true;
    return false;
  };

  const handleSave = () =>
    saveForm("isFinish", () => navigate("/onboarding/welcome?callback=/app/home"));

  const handleCreateTeam = () =>
    saveForm("teamCreate", () => navigate("/onboarding/team"));

  return (
    <div className="px-8 container max-w-screen-xl mx-auto flex flex-col items-center min-h-[70vh]">
       <TitleText
        title={` ${currentStageData.title}`}
      />

      <StageRenderer
        stage={currentStageData}
        loading={loading}
        handleCreateTeam={handleCreateTeam}
        isTeamCreated={form.isTeamCreated}
        isDisabled ={form.isLoading}
      />

      <div className="absolute bottom-0 left-0 w-full py-8">
        <BottomSection
          currentStage={currentStage}
          STAGES={STAGES}
          handleBack={handleBack}
          handleSave={handleSave}
          handleNext={handleNext}
          isNextDisabled={isNextDisabled}
          isLoading={form.isLoading}
          isDisabled ={form.isTeamCreated}
        />
      </div>
    </div>
  );
}
